import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import QueueDashboard from "../../app/QueueDashboard";
import "../../app/globals.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Missing #root element");
}

createRoot(root).render(
  <StrictMode>
    <QueueDashboard />
  </StrictMode>,
);
